import type { FacetFilters } from '@/types/catalog'

interface ProductQueryParams {
  department?: number
  families?: number[]
  subdepartments?: number[]
  filters?: FacetFilters
  productCode?: string | null
  isNew?: boolean
}

export function createProductQueryParams({
  department,
  families,
  subdepartments,
  filters = {},
  productCode,
  isNew,
}: ProductQueryParams): URLSearchParams {
  const params = new URLSearchParams()

  if (department !== undefined)
    params.set('department', department.toString())

  Object.entries({ families, ...(!families?.length && { subdepartments }), ...filters }).forEach(([name, values]) => {
    if (values?.length)
      params.set(name, values.join(','))
  })

  if (productCode) {
    params.set('product_code', productCode)
  }

  if (isNew) {
    params.set('is_new', 'true')
  }

  return params
}
